import ROUTES from './Routes';

const ROUTES_WITH_BACKGROUND = [
  ROUTES.REGISTRATION,
];

export default ROUTES_WITH_BACKGROUND;
